var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    React.createElement(
      "title",
      null,
      "\uD83D\uDEA7/Tab Bar/Icon/Messages"
    ),
    React.createElement(
      "defs",
      null,
      React.createElement("path", { d: "M22 10.567c-.027-2.087-.81-3.87-2.348-5.348C18.113 3.739 16.265 3 14.105 3h-4.21c-2.187 0-4.049.74-5.587 2.219C2.769 6.698 2 8.493 2 10.606c0 2.113.762 3.916 2.287 5.408 1.525 1.492 3.368 2.238 5.527 2.238h3.198v3.605c0 .159.081.185.243.08l6.397-5.824C21.217 14.581 22 12.733 22 10.567z", id: "navbar-messages" })
    ),
    React.createElement(
      "g",
      { id: "\uD83D\uDEA7/Tab-Bar/Icon/Messages", fill: "none", fillRule: "evenodd" },
      React.createElement(
        "mask",
        { id: "mask-2", fill: "#fff" },
        React.createElement("use", { xlinkHref: "#navbar-messages" })
      ),
      React.createElement("use", { id: "Icon", fill: "#e4edfd", xlinkHref: "#navbar-messages" })
    )
  );
});


// WEBPACK FOOTER //
// ./src/shared/components/svgs/Messages.svg